import React, { useEffect, useState } from 'react';
import Quize from '../Quize/Quize';
import './Quizzes.css'

const Quizes = () => {
          const [quizzes ,setQuizzes] =useState([])
          useEffect(()=>{
                    fetch('Quizzes.json')
                    .then(res=>res.json())
                    .then(data => setQuizzes(data))
          },[])
          return (
                    <div className='main md:w-2/4 mx-auto h-auto md:h-auto p-9 pb-5 my-3'>
                    <div className="title  mb-2 p-3">
                                   <h1 className='text-xl md:text-3xl font-serif text-center'>জাতীয় বন এবং প্রাণী </h1> 
                                   <h1 className='text-sm my-2  text-center'>National Forest and Animals</h1> 
                    </div>  
                    <div className="quiz  h-auto ">
                   {
                             quizzes.map(quiz => <Quize key={quiz.id} quiz={quiz} ></Quize>)
                   }
                              
                    </div>
                    <div className="btns  mt-3 h-[55px] flex items-center justify-center">
                              <button className="Previous border px-8 rounded-full mx-1 py-2 bg-red-500 text-white font-bold">Previous</button>
                              <button className="Previous border px-8 rounded-full mx-1 py-2 bg-red-500 text-white font-bold">Next</button>
                    </div>
                    </div>
          );
};

export default Quizes;